import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'get',
  url: '/wagons',
};

export const getWagonRequest = (wagonId: number) =>
  createRequest({
    url: `${config.url}/${wagonId}.json`,
    method: config.method,
  });
